module.exports = __webpack_public_path__ + "img/elena-serebryakova.219ba6f8.jpg";